import styles from "./common.module.css";
import React, { useState } from "react";
import Bus from "../../event/bus";
import { useLocation } from "react-router-dom";

const NavBar = () => {
  const [openSettings, setOpenSettings] = useState(false);
  const location = useLocation();

  const removeMenu = () => {
    setOpenSettings(false);
  };

  const toggleSidebar = () => {
    Bus.emit("toggle-sidebar");
  };

  //Route info
  const routeParam = location?.pathname;
  const routeArray = routeParam?.split("/");
  let routeTitle;

  if (!routeArray) {
    routeTitle = "Dashboard";
  } else {
    const lastValue = routeArray[routeArray?.length - 1];
    const likelyOffers = routeArray[routeArray?.length - 2];
    if (likelyOffers === "offers") {
      routeTitle = "";
    } else {
      routeTitle = lastValue.replace('-'," ").toLowerCase()
    }
  }

  return (
    <div>
      {openSettings && (
        <div
          className="absolute bg-red-00 inset-0 z-10"
          onClick={removeMenu}
        ></div>
      )}
      <header className="!w-full bg-white z-30 h-20 text-white font-medium flex justify-between items-center ">
        <div className="px-6 w-full">
          <div className="flex justify-between items-center h-16">
            <div className="flex">
              <button onClick={toggleSidebar} className="sm:hidden">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-[#000]"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              </button>
              <div className="hidden md:flex items-center">
                <div className="">
                  <p
                    className={`${styles.dashboard} ${styles.capitalizeFirstLetter} `}
                  >
                    {routeTitle}
                  </p>
                </div>
              </div>
            </div>
            <div >
              <p className={styles.time}>Monday 08-05-2023 07:32am</p>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default NavBar;
